/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var productFromCard = document.querySelector(
  ".product-block-list__wrapper .card--sticky"
);

if (productFromCard) {
  document.documentElement.style.setProperty(
    "--product-form-height",
    productFromCard.clientHeight + "px"
  );
}
const paragraphs = document.querySelectorAll(".colo-swatch");
paragraphs.forEach(
  (p) =>
    (p.onchange = function (event) {
      let get_val = event.target.selectedOptions[0].getAttribute("data-price");
      console.log(event.path[3].querySelector(".price"));
      event.path[3].querySelector(".price").textContent = "From " + get_val;
      console.log(event.composedPath);
      console.log(event.path[3].querySelector(".price"));
      //console.log(event.path.getAttribute('class'));
      console.log("Value from the Attribute: ", get_val);
    })
);

$(document).ready(function () {
  $(document).on(
    "click",
    "#variant-tables--wrap--js .quantity-selector__button",
    function () {
      //console.log('ttt')
      var $el = $(this),
        $el_wrap = $el.closest(".quantity-selector"),
        action_for = $el.data("action"),
        $input = $el_wrap.find(".quantity-selector__value"),
        variant_id = $input.data("variant-id"),
        val = parseInt($input.val()),
        line = -1;
      buttonDisabled(true);
      if (action_for == "increase-picker-quantityy") {
        val = val + 1;
      } else {
        if (val > 0) val = val - 1;
      }
      $input.val(val);
      var getCart = window.getCart();
      getCart.then((cart) => {
        cart.items.forEach((item, index) => {
          if (item.id == variant_id) {
            line = index + 1;
          }
        });
        if (line == -1) {
          addProduct(variant_id);
        } else {
          updateProduct(variant_id, val);
        }
      });
    }
  );

  $(document).on("click", ".filter_label", function () {
    var $el = $(this),
      $next = $el.next(),
      $el_wrap = $el.closest(".filter_wrap");
    if ($el_wrap.hasClass("without_dropdown")) {
      $el_wrap.find(".single_tag--item").trigger("click");
    } else {
      $el.toggleClass("active");
      $next.slideToggle();
    }
  });

  $(document).on("click", ".clearFilter", function () {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    var $el = $(this),
      $el_main_wrap = $el.closest(".filter_main__wrap"),
      colllectionURL = $("#colllectionURL").val(),
      currentURL = window.location.href,
      currentURLQueryString =
        currentURL.indexOf("?") != -1 ? currentURL.split("?")[1] : "",
      fetchURL = colllectionURL + "?" + currentURLQueryString;
    console.log(fetchURL);
    applyFilter(fetchURL);
  });

  function clearfilter() {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    var $el = $(".clearFilter"),
      $el_main_wrap = $el.closest(".filter_main__wrap"),
      colllectionURL = $("#colllectionURL").val(),
      currentURL = window.location.href,
      currentURLQueryString =
        currentURL.indexOf("?") != -1 ? currentURL.split("?")[1] : "",
      fetchURL = colllectionURL + "?" + currentURLQueryString;
    console.log(fetchURL);
    applyFilter(fetchURL);
  }

  $(document).on("change", ".filter-checkbox--js", function () {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    var $el = $(this),
      $el_item_wrap = $el.closest("fiter_item"),
      $el_wrap = $el.closest(".filter_wrap"),
      $el_main_wrap = $el.closest(".filter_main__wrap"),
      active_filters = [],
      colllectionURL = $("#colllectionURL").val(),
      currentURL = window.location.href,
      currentURLQueryString =
        currentURL.indexOf("?") != -1 ? currentURL.split("?")[1] : "",
      fetchURL = "";

    $el_wrap.find(".filter-checkbox--js").not(this).prop("checked", false);

    if ($el.prop("checked")) {
      $el_item_wrap.addClass("active");
    } else {
      $el_item_wrap.removeClass("active");
    }
    var single_tag__item = false,
      singleTAG = "";

    $el_main_wrap.find(".filter-checkbox--js:checked").each(function () {
      var filter = $(this).val(),
        $wrap = $(this).closest(".fiter_item");

      if ($wrap.hasClass("single_tag--item")) {
        if (currentURL?.indexOf(filter) == -1) {
          singleTAG = filter;
          single_tag__item = true;
          return false;
        } else {
          return true;
        }
      }

      //  console.log(tags_length);
      active_filters.push(filter);
    });
    if (single_tag__item) {
      fetchURL = colllectionURL + "/" + singleTAG + "?" + currentURLQueryString;
    } else {
      active_filters = active_filters.join("+");
      fetchURL =
        colllectionURL + "/" + active_filters + "?" + currentURLQueryString;
    }
    // console.log(fetchURL);
    applyFilter(fetchURL);
    ///preventQty();
    //QuantityInput();
    //activateNoHingeSideProducts();
  });
});

function applyFilter(paramsURL) {
  var fetchURL = removeURLParameter(paramsURL, "page");
  //console.log('fetchURL>>',fetchURL);
  fetch(fetchURL)
    .then((response) => response.text())
    .then((data) => {
      // console.log(data);
      /*var html = $(data).find('#mainCollectionDynamicWrapper');
    $('#mainCollectionDynamicWrapper').html(html);
    window.history.pushState({"html":"","pageTitle":""},"", fetchURL);
    document.dispatchEvent(new CustomEvent('theme:loading:end')); */
      window.location.href = fetchURL;
    });
}

function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split("?");
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
  }
  return url;
}

function addProduct(id) {
  let formData = {
    items: [
      {
        id: id,
        quantity: 1,
      },
    ],
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      buttonDisabled(false);
      var maxHeight =
        window.innerHeight -
        document.querySelector(".header").getBoundingClientRect().bottom;

      console.log(maxHeight);
      $("#mini-cart").css("min-height", maxHeight + "px");
      $(".header__cart-toggle").attr("aria-expanded", "true");
      $(".header__cart-icon").attr("aria-expanded", "true");
      $("#mini-cart").attr("aria-hidden", "false");
      return response.json();
    })
    .catch((error) => {
      buttonDisabled(false);
      console.error("Error:", error);
    });
}

function updateProduct(id, qty) {
  let formData = {
    updates: {},
  };
  formData["updates"][parseInt(id)] = qty;
  let info = fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      buttonDisabled(false);
    })
    .catch((error) => {
      buttonDisabled(false);
      console.error("Error:", error);
    });
}

window.getCart = async function () {
  var response = await fetch("/cart.js");
  return response.json();
};

window.updateInputBox = function () {
  var CartBox = window.getCart();
  $("#variant-tables--wrap--js .quantity-selector__value").val(0);
  CartBox.then((cart) => {
    cart.items.forEach((item) => {
      if (
        $(
          '#variant-tables--wrap--js .quantity-selector__value[data-variant-id="' +
            item.id +
            '"]'
        ).length
      ) {
        $(
          '#variant-tables--wrap--js .quantity-selector__value[data-variant-id="' +
            item.id +
            '"]'
        ).val(item.quantity);
      }
    });
  });
};

function buttonDisabled(flag) {
  document.dispatchEvent(new CustomEvent("cart:customRefresh"));
  $("#variant-tables--wrap--js .quantity-selector__button").prop(
    "disabled",
    flag
  );
  if (flag) {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
  } else {
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }, 1000);
  }
}

document.querySelectorAll(".filter_cls .checkbox").forEach((itm) => {
  itm.onclick = (e) => {
    document.querySelectorAll(".filter_cls .checkbox").forEach((itm2) => {
      itm2.parentNode.parentNode.classList.remove("active");
    });
    e.target.parentNode.parentNode.classList.add("active");
  };
});
